import React, { useState, ChangeEvent } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateFormControlValueAction } from '../actions/formActions';
import { IControlProps, IFormMeta } from '../types/IFormSettings';
import { controlSelector, formKeySelector } from '../selectors/formBuilder.selector';
import { isAntiFraudControl } from '../helpers/antiFraudHelper';

function InputForm({ controlName, formName }: IControlProps) {
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const { value, minLength, maxLength, readonly, disabled, placeholder, type } = useSelector(
        controlSelector(formName, controlName),
    );

    const { formMeta = {} as IFormMeta } =
    useSelector(formKeySelector(formName, 'initialSettings')) || {};

    const dispatch = useDispatch();

    const onFocus = () => {
        setIsFocused(true);
        setInputValue(value);

        if (type === 'number' && value === '0') {
            setInputValue('');
        }
    };

    const onBlurHandler = (e: ChangeEvent<HTMLInputElement>) => {
        setIsFocused(false);
        const input = e.currentTarget;
        if ((type === 'number' || isAntiFraudControl(formMeta.enableCrestt, controlName)) && !input.value.length) {
            input.value = '0';
        }

        dispatch(
            updateFormControlValueAction({
                formName,
                value: input.value,
                controlName,
            }),
        );
    };

    const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) =>
        setInputValue(e.currentTarget.value);

    return (
        <input
            onFocus={onFocus}
            onBlur={onBlurHandler}
            onChange={onChangeHandler}
            className="form-control"
            id={controlName}
            type={type}
            value={isFocused ? inputValue : value}
            name={controlName}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readonly}
            maxLength={maxLength}
            minLength={minLength}
        />
    );
}

export default InputForm;
